import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/app/category/[slug]/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/EzoicHandler.tsx");
